module.exports = __webpack_public_path__ + "img/customer_service.d394c45b.jpg";